// import React from 'react';
// import { useSelector } from 'react-redux';
// import { Route, Redirect } from 'react-router-dom';

// const PrivateRoute = props => {
//     const { component: Component, ...restProps } = props;
//     const loggedIn = useSelector(({userReducer}) => userReducer.loggedIn);

//     return <Route {...restProps} render={props => (loggedIn ? <Component {...props} /> : <Redirect to={`/login`} />)} />;
// };

// export default PrivateRoute;

import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { hasPermission } from "../scenes/Setting/permissionHelper";
import PermissionDenied from "../scenes/Setting/PermissionDenied";
import Loader from "./Loader/Lodaer";
import config from "../config/config";

const PrivateRoute = props => {
    const { component: Component, permissionKey, ...restProps } = props;

    const loggedIn = useSelector(({ userReducer }) => userReducer.loggedIn);
    // const permissionsData = useSelector(
    //     (state) => state.rolePermissionReducer.userPermissionData
    //   );
    const {userPermissionData,permissionLoading }= useSelector(
        (state) => state.rolePermissionReducer
      );
    //   const permissionLoaded = permissionsData && Object.keys(permissionsData).length > 0;
    // Check permission
    const hasPermissionAllowed =
        permissionKey ? hasPermission(userPermissionData, permissionKey) : true;
        
    return (
        <Route
            {...restProps}
            render={routeProps =>{
                if(!loggedIn) {
                    return <Redirect to="/login" />;
                }

                if (config.enablePermissionCheck && permissionLoading) {
                    // Permissions not fetched yet → show loader
                    return (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100vh',
                                width: '100vw',
                                flexDirection: 'column',
                                gap: '10px',
                                fontSize: '16px',
                                color: '#000',
                                backgroundColor: '#fff'
                            }}
                        >
                            <Loader label="Loading..." />
                        </div>
                    );
                }

                return  hasPermissionAllowed ? (
                    <Component {...routeProps} />
                ) : (
                    <PermissionDenied />
                )
            }}
        />
    );
};

export default PrivateRoute;


